import Controller, { OnClose, OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

@Controller({ fragment: 'forget-password-request-email-not-found', component: 'root-modal' })
class ForgetPasswordRequestEmailNotFoundController extends BaseController {

  @OnClick({ target: ['try-again-button'] })
  onButtonClose(): void {
    this.historyService.push(APPLICATION_ROUTES.FORGET_PASSWORD);
  }

  @OnClose({ target: ['root-modal'] })
  onRootModalClose(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }
}

export default ForgetPasswordRequestEmailNotFoundController;